import logo from './logo.svg';
import './App.css';

import { Routes, Route } from "react-router-dom";
import Abt from './components/Abt';
import Range from './components/Range';
import Home from './components/Home';
import Contact from './components/Cont';
import Whattsappbutton from './components/Whattsappbutton';


function App() {
  return (
    <>
     <Whattsappbutton/>
     
   <Routes>
    <Route>
       
       <Route path="/" element={<Home />} />
        <Route path="/about" element={<Abt />} />
         <Route path="/range" element={<Range />} />
          <Route path="/contact" element={<Contact />} />
    </Route>
   </Routes>

    </>
  );
}

export default App;
